var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
      'row': true,
      'wrapper': true,
      'secondary': _vm.isSecondaryLayout
    }},[_c('div',{staticClass:"col left-column"},[_vm._t("left-column")],2),_c('div',{staticClass:"col right-column"},[_c('div',{staticClass:"right-column-content"},[_vm._t("right-column")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }